import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CreateCashierTransaction from './pages/CreateCashierTransaction';
import ListCashierTransaction from './pages/ListCashierTransaction';

const CashierTransaction = () => {
  return (
    <Routes>
      <Route path="create" element={<CreateCashierTransaction />} />
      <Route path="" element={<ListCashierTransaction />} />
    </Routes>
  );
};

export default CashierTransaction;
